export const pushSubsTypes = {
  FETCH_PUSH_SUBS_PENDING: 'FETCH_PUSH_SUBS_PENDING',
  FETCH_PUSH_SUBS_SUCCESS: 'FETCH_PUSH_SUBS_SUCCESS',
  FETCH_PUSH_SUBS_FAILED: 'FETCH_PUSH_SUBS_FAILED',
  DELETE_PUSH_SUBS: 'DELETE_PUSH_SUBS',
};
